/**
 * Full-page film grain texture overlay.
 * Renders a fixed-position div styled via the `.grain-overlay` CSS class,
 * adding a subtle analogue grain effect across the entire viewport.
 */
const GrainOverlay = () => {
  return <div className="grain-overlay" aria-hidden="true" />;
};

export default GrainOverlay;
